<template>
  <div>
    <div>
      <div class="item">
        <span class="title">消耗时间</span>
        <el-date-picker
          v-model="date"
          :picker-options="expireTimeOption"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        />
      </div>
      <div class="item">
        <span class="title">新用户充值时间</span>
        <el-date-picker
          v-model="dates"
          :picker-options="expireTimeOption"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        />
      </div>
      <div class="item">
        <span class="title">主渠道号</span>
        <el-autocomplete
          v-model="parameterNames.master_appid_name"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入内容"
          :clearable="true"
          @clear="(parameterNames.master_appid_name = null),(parameter.master_appid = null)"
          @focus="current = '主渠道号'"
          @select="handleSelect"
        />
      </div>

      <div class="item">
        <span class="title">副渠道号</span>
        <!-- <el-select
          v-model="officialValue"
          multiple
          filterable
          remote
          collapse-tags
          reserve-keyword
          placeholder="请输入关键词"
          :loading="loading"
          :remote-method="remoteMethod"
          @focus="activation"
          @change="change"
        >
          <el-option
            v-for="item in fromOfficialAccount"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <span style="font-size: 32px; display: inline-block; margin: 0px 10px;">/</span> -->
        <div>
          <el-input v-model="multipleSub" style="width:150px" placeholder="请输入多个的名字" @input="handleParams" />
          <el-button type="primary" style="margin-left:10px" @click="multipleSubOfficialAccount">选中多个</el-button>
        </div>
      </div>
      <div class="checkBox">
        <span class="checkBox_title">选中的渠道号</span>
        <div class="checkBox_content">
          <el-tag
            v-for="item in officialObj"
            :key="item.value"
            class="content_item"
            style="margin: 5px;"
            size="small"
          >
            {{ item.value }}
            <i
              class="el-icon-close"
              style="font-size: 18px;"
              @click="deleteOfficialAccount(item)"
            /></el-tag>
        </div>

      </div>
      <div class="item">
        <span class="title">投放组</span>
        <el-autocomplete
          v-model="parameterNames.release_group_id_name"
          :fetch-suggestions="querySearchAsync"
          :clearable="true"
          placeholder="请输入内容"
          @clear="(parameterNames.release_group_id_name = null),(parameter.release_group_id = null)"
          @focus="current = '投放组'"
          @select="handleSelect"
        />
      </div>

      <div class="item">
        <span class="title">投手</span>
        <el-autocomplete
          v-model="parameterNames.pitcher_id_name"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入内容"
          :clearable="true"
          @clear="(parameterNames.pitcher_id_name = null),(parameter.pitcher_id = null)"
          @focus="current = '投手'"
          @select="handleSelect"
        />
      </div>
      <div class="item">
        <span class="title">书籍归属</span>
        <el-autocomplete
          v-model="parameterNames.book_id_name"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入内容"
          :clearable="true"
          @clear="(parameterNames.book_id_name = null),(parameter.book_id = null)"
          @focus="current = '书籍归属'"
          @select="handleSelect"
        />
      </div>

      <div class="item">
        <span class="title">书名</span>
        <el-autocomplete
          v-model="parameterNames.alias_book_id_name"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入内容"
          :clearable="true"
          @clear="(parameterNames.alias_book_id_name = null),(parameter.alias_book_id = null)"
          @focus="current = '书名'"
          @select="handleSelect"
        />
      </div>

      <div class="item">
        <span class="title">投放位置</span>
        <el-autocomplete
          v-model="parameterNames.position_id_name"
          :fetch-suggestions="querySearchAsync"
          :clearable="true"
          placeholder="请输入内容"
          @clear="(parameterNames.position_id_name = null),(parameter.position_id = null)"
          @focus="current = '投放位置'"
          @select="handleSelect"
        />
      </div>

      <div class="item">
        <span class="title">ADQ广告主</span>
        <div>
          <el-input v-model="multipleSub1" style="width:150px" placeholder="请输入多个的名字" @input="handleParams1($event, 1)" />
          <el-button type="primary" style="margin-left:10px" @click="multipleSubOfficialAccount1(1)">选中多个</el-button>
        </div>
      </div>
      <div class="checkBox">
        <span class="checkBox_title">选中的ADQ广告主</span>
        <div class="checkBox_content">
          <el-tag v-for="item in advertiserObj" :key="item.value" class="content_item" style="margin: 5px;" size="small">{{ item.label }}<i class="el-icon-close" style="font-size: 18px;" @click="deleteOfficialAccount1(item, 1)" /></el-tag>
        </div>

      </div>
      <div class="item">
        <span class="title">巨量广告</span>
        <div>
          <el-input v-model.trim="multipleSub2" style="width:150px" placeholder="请输入多个的名字" @input="handleParams1($event, 2)" />
          <el-button type="primary" style="margin-left:10px" @click="multipleSubOfficialAccount1(2)">选中多个</el-button>
        </div>
      </div>
      <div class="checkBox">
        <span class="checkBox_title">选中的巨量广告</span>
        <div class="checkBox_content">
          <el-tag v-for="item in advertiserObj1" :key="item.value" class="content_item" style="margin: 5px;" size="small">{{ item.label }}<i class="el-icon-close" style="font-size: 18px;" @click="deleteOfficialAccount1(item, 2)" /></el-tag>
        </div>
      </div>

      <div class="item">
        <span class="title">平台id</span>
        <el-select
          v-model="parameter.platform_id"
          style="margin-right: 20px"
          placeholder="请选择平台"
          filterable
          :clearable="true"
          @clear="parameter.platform_id = null"
        >
          <el-option
            v-for="(item, index) in platformSelectList"
            :key="index"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </div>
    </div>

    <div style="text-align: end; margin-top:20px">
      <el-button class="" type="primary" @click="determine">确定</el-button>
    </div>
  </div>
</template>

<script>
import { getTheListOfOfficialAccountNovel, getReleaseGroupListNovel, getListOfPitchersInTheLaunchGroupNovel, getTitleListNovel, getBookOwnershipListNovel, dropLocationListNovel, getAdvertiserNovel, getPlatform } from '@/api/newLaunchGroup.js'
export default {
  props: {
    drawerItem: {
      type: Object,
      default() {
        return {

        }
      }
    }
  },
  data() {
    return {
      expireTimeOption: {
        disabledDate(date) {
          return (
            date.getTime() < new Date(new Date().getFullYear(), 0, 1).getTime() ||
            date.getTime() > new Date(new Date().getFullYear(), 11, 31).getTime()
          )
        }
      },
      parameter: {
        master_appid: null, // 主渠道号
        release_group_id: null, // 投放组
        pitcher_id: null, // 投手
        alias_book_id: null, // 书名
        book_id: null, // 书籍归属
        position_id: null, // 投放位置
        platform_id: null // 平台
      },
      parameterNames: {
        master_appid_name: null, // 主渠道号
        release_group_id_name: null, // 投放组
        pitcher_id_name: null, // 投手
        alias_book_id_name: null, // 书名
        book_id_name: null, // 书籍归属
        position_id_name: null, // 投放位置
        app_id_name: null // 平台
      },
      current: null,
      loading: false,
      loading1: false,
      date: [],
      dates: [],
      officialValue: [], // 副渠道号值
      fromOfficialAccount: [], // 从渠道号
      officialObj: [], // 辅助渲染的渠道号
      platformSelectList: [],
      advertiserValue: [], // 广告主值
      advertiserValue1: [], // 巨量广告主值
      fromAdvertiser: [], // 广告主
      fromAdvertiser1: [], // 巨量广告
      advertiserObj: [], // 辅助广告主渲染
      advertiserObj1: [], // 辅助巨量广告渲染
      multipleSub: null, // 输入的多个从渠道号的名字
      multipleSub1: null, // 输入的多个广告主的名字
      multipleSub2: null // 输入的多个巨量广告的名字
    }
  },
  created() {
    window.aaa = this
    this.myGetchannelplatform() // 获取平台
    this.init()
  },
  mounted() {
  },
  methods: {
    // 选中哪一项
    handleSelect(item) {
      switch (this.current) {
        case '主渠道号' : this.parameter.master_appid = item
          break
        case '投放组' : this.parameter.release_group_id = item
          break
        case '投手' : this.parameter.pitcher_id = item
          break
        case '书名' : this.parameter.alias_book_id = item
          break
        case '书籍归属' : this.parameter.book_id = item
          break
        case '投放位置' : this.parameter.position_id = item
          break
      }
    },
    // 搜索
    async querySearchAsync(queryString, cb) {
      let currentFunc = null
      const obj = {
        '主渠道号': 'channel_code',
        '投放组': 'release_group_name',
        '投手': 'user_name',
        '书籍归属': 'book_name',
        '书名': 'novel_name',
        '投放位置': 'position_name'
      }

      switch (this.current) {
        case '主渠道号': currentFunc = getTheListOfOfficialAccountNovel
          break
        case '从渠道号': currentFunc = getTheListOfOfficialAccountNovel
          break
        case '投放组': currentFunc = getReleaseGroupListNovel
          break
        case '投手': currentFunc = getListOfPitchersInTheLaunchGroupNovel
          break
        case '书名': currentFunc = getTitleListNovel
          break
        case '书籍归属': currentFunc = getBookOwnershipListNovel
          break
        case '投放位置': currentFunc = dropLocationListNovel
          break
      }
      if (!currentFunc) {
        return
      }
      if (this.current === '投手' && !this.parameter.release_group_id || this.current === '书名' && !this.parameter.book_id || this.current === '从渠道号' && !this.parameter.master_appid) {
        const obj1 = {
          '投手': '请先选投放组，才能选投手',
          '书名': '请先选择书籍归属，才能选书名',
          '从渠道号': '请先选择主渠道号，才能选从渠道号'
        }
        this.$message({
          message: obj1[this.current],
          type: 'warning'
        })
        cb()
        return
      }
      const data = await currentFunc({
        name: queryString || null,
        group_id: this.current === '投手' ? this.parameter.release_group_id.address : null,
        book_belong_id: this.parameter.book_id ? this.parameter.book_id.address : null
      })
      cb(data.data.list.map((item) => {
        return {
          value: this.current === '书名' ? item['novel_name'] + (item['platform'] ? '(' + item['platform'] + ')' : '') : item[obj[this.current]],
          address: this.current === '主渠道号' ? item[obj[this.current]] : item.id
        }
      }))
    },
    // 请求平台
    async myGetchannelplatform() {
      const data = await getPlatform({ type: 1 })
      this.platformSelectList = data.data.list
    },
    // 请求初始书名
    async getTitleList() {
      const data = await getTitleListNovel({
        book_alias_id: this.drawerItem.alias_book_id,
        // page: 1,
        // pageSize: 20,
        book_belong_id: this.drawerItem.book_id
      })
      // 书名
      this.parameterNames.alias_book_id_name = data.data.list[0] && data.data.list[0].novel_name && data.data.list[0].novel_name + (data.data.list[0].platform ? '(' + data.data.list[0].platform + ')' : '')
      this.parameter.alias_book_id = this.parameterNames.alias_book_id_name && {
        value: this.parameterNames.alias_book_id_name,
        address: this.drawerItem.alias_book_id
      }
    },
    // 选择渠道号
    change(items) {
      if (!items.length) {
        this.officialObj = []
        return
      }
      for (let i = 0; i < items.length; i++) {
        const im = items[i]
        const index = this.officialObj.findIndex(itemm => itemm.value === im)
        if (index < 0) {
          this.officialObj.push({
            value: im,
            label: this.fromOfficialAccount[this.fromOfficialAccount.findIndex(itemm => itemm.value === im)].label
          })
        } else {
          this.officialObj = this.officialObj.filter((imm) => {
            return !(items.indexOf(imm.value) < 0)
          })
        }
      }
    },

    // 删除渠道号
    deleteOfficialAccount(item) {
      this.officialObj.splice(this.officialObj.findIndex(im => im.value === item.value), 1)
      this.officialValue.splice(this.officialValue.indexOf(item.value), 1)
    },
    // 选择广告主
    change1(item) {
      for (let i = 0; i < this.advertiserValue.length; i++) {
        const im = this.advertiserValue[i]
        const index = this.advertiserObj.findIndex(itemm => itemm.value === im)
        index < 0 && this.advertiserObj.push({ value: im, label: this.fromAdvertiser[this.fromAdvertiser.findIndex(itemm => itemm.value === im)].label })
      }
      this.advertiserObj = this.advertiserObj.filter((imm) => {
        return !(item.indexOf(imm.value) < 0)
      })
    },
    // 选择巨量
    change2(item) {
      console.log(this.advertiserValue1)
      for (let i = 0; i < this.advertiserValue1.length; i++) {
        const im = String(this.advertiserValue1[i]) // 统一转换为字符串
        const index = this.advertiserObj1.findIndex(itemm => String(itemm.value) === im)
        console.log(this.fromAdvertiser1.findIndex(itemm => String(itemm.value) === im))
        index < 0 && this.advertiserObj1.push({ value: im, label: this.fromAdvertiser1[this.fromAdvertiser1.findIndex(itemm => String(itemm.value) === im)].label })
      }
      this.advertiserObj1 = this.advertiserObj1.filter((imm) => {
        return !(item.indexOf(String(imm.value)) < 0)
      })
    },

    // 删除广告主
    deleteOfficialAccount1(item, index) {
      if (index === 1) {
        this.advertiserObj.splice(this.advertiserObj.findIndex(im => im.value === item.value), 1)
        this.advertiserValue.splice(this.advertiserValue.indexOf(item.value), 1)
      } else {
        this.advertiserObj1.splice(this.advertiserObj1.findIndex(im => String(im.value) === String(item.value)), 1)
        this.advertiserValue1.splice(this.advertiserValue1.indexOf(String(item.value)), 1)
      }
    },

    // 确定
    determine() {
      if (this.judgmentParameters()) {
        const parameter = this.assemblyParameters()
        this.$emit('determine', parameter)
      }
    },

    // 判断参数
    judgmentParameters() {
      let text = null
      if (!this.parameter.master_appid || this.parameter.master_appid.value !== this.parameterNames.master_appid_name) {
        text = '请选择主渠道号'
      } else if (!this.parameter.release_group_id || this.parameter.release_group_id.value !== this.parameterNames.release_group_id_name) {
        text = '请选择投放组'
      } else if (!this.parameter.pitcher_id || this.parameter.pitcher_id.value !== this.parameterNames.pitcher_id_name) {
        text = '请选择投手'
      } else if (!this.parameter.book_id || this.parameter.book_id.value !== this.parameterNames.book_id_name) {
        text = '请选择书籍归属'
      } else if (!this.parameter.alias_book_id || this.parameter.alias_book_id.value !== this.parameterNames.alias_book_id_name) {
        text = '请选择书名'
      } else if (!this.parameter.position_id || this.parameter.position_id.value !== this.parameterNames.position_id_name) {
        text = '请选择投放位置'
      } else if (!this.advertiserValue.length && !this.advertiserValue1.length) {
        text = '请选择ADQ广告主或者巨量广告'
      } else if (!this.parameter.platform_id) {
        text = '请选择平台'
      } else if (!this.date || !this.date.length) {
        text = '请选择日期'
      } else if (!this.dates || !this.dates.length) {
        text = '请选择新用户充值时间'
      }

      text && this.$message({
        message: text,
        type: 'warning'
      })

      return !text
    },

    // 组装参数
    assemblyParameters() {
      const obj = {
        begin_time: this.date[0],
        end_time: this.date[1],
        recharge_begin: this.dates[0],
        recharge_end: this.dates[1],
        master_channel_code: this.parameter.master_appid.address,
        channel_codes: this.officialValue,
        release_group_id: this.parameter.release_group_id.address,
        pitcher_id: this.parameter.pitcher_id.address,
        alias_book_id: this.parameter.alias_book_id.address,
        book_id: this.parameter.book_id.address,
        position_id: this.parameter.position_id.address,
        adq_advertiser_ids: this.advertiserValue,
        ocean_advertiser_ids: this.advertiserValue1,
        platform_id: this.parameter.platform_id
      }

      return obj
    },

    // 初始化
    init() {
      if (this.drawerItem && this.drawerItem.id) {
        this.getTitleList()
      } else {
        // 书名
        this.parameterNames.alias_book_id_name = this.drawerItem.novel_name
        this.parameter.alias_book_id = this.parameterNames.alias_book_id_name && {
          value: this.parameterNames.alias_book_id_name,
          address: this.drawerItem.alias_book_id
        }
      }
      if (this.drawerItem.begin_time && this.drawerItem.end_time) {
        // 时间
        this.date[0] = this.drawerItem.begin_time
        this.date[1] = this.drawerItem.end_time
      }
      if (this.drawerItem.recharge_begin && this.drawerItem.recharge_end) {
        // 新用户充值时间
        this.dates[0] = this.drawerItem.recharge_begin
        this.dates[1] = this.drawerItem.recharge_end
      }
      // 主公众号
      this.parameterNames.master_appid_name = this.drawerItem.master_channel_code ? this.drawerItem.master_channel_code : null
      this.parameter.master_appid = this.parameterNames.master_appid_name && {
        value: this.drawerItem.master_channel_code,
        address: this.drawerItem.master_channel_code
      }
      // 投放组
      this.parameterNames.release_group_id_name = this.drawerItem.release_group_name
      this.parameter.release_group_id = this.parameterNames.release_group_id_name && {
        value: this.drawerItem.release_group_name,
        address: this.drawerItem.release_group_id
      }

      // 投手
      this.parameterNames.pitcher_id_name = this.drawerItem.pitcher_name
      this.parameter.pitcher_id = this.parameterNames.pitcher_id_name && {
        value: this.drawerItem.pitcher_name,
        address: this.drawerItem.pitcher_id
      }
      // 书籍归属
      this.parameterNames.book_id_name = this.drawerItem.belong_name
      this.parameter.book_id = this.parameterNames.book_id_name && {
        value: this.drawerItem.belong_name,
        address: this.drawerItem.book_id
      }
      // 投放位置
      this.parameterNames.position_id_name = this.drawerItem.position_name
      this.parameter.position_id = this.parameterNames.position_id_name && {
        value: this.drawerItem.position_name,
        address: this.drawerItem.position_id
      }
      // 副公众号
      this.officialValue = (this.drawerItem.channel_codes && this.drawerItem.channel_codes.length) ? [...Object.values(this.drawerItem.channel_codes).filter(item => item !== this.drawerItem.master_channel_code)] : []
      // console.log('======', this.officialValue, this.fromOfficialAccount)
      this.fromOfficialAccount = this.officialValue.map((item, index) => {
        return {
          value: item,
          label: this.drawerItem.channel_codes[index]
        }
      })

      this.officialObj = this.officialValue.map((item, index) => {
        return {
          value: item,
          label: this.drawerItem.channel_codes[index]
        }
      })
      // 广告主
      this.advertiserValue = (this.drawerItem.adq_advertiser_ids && this.drawerItem.adq_advertiser_ids.length) ? [...this.drawerItem.adq_advertiser_ids] : []
      this.fromAdvertiser = this.advertiserValue.length ? this.drawerItem.adq_advertiser.map((item, index) => {
        return {
          value: item.account_id,
          label: `${item.account_name && item.account_id ? item.account_name + '--' : item.account_name}${item.account_id && item.agent_name ? item.account_id + '--' : item.account_id}${item.agent_name || ''}`
        }
      }) : []
      this.advertiserObj = this.advertiserValue.length ? this.drawerItem.adq_advertiser.map((item, index) => {
        return {
          value: item.account_id,
          label: `${item.account_name && item.account_id ? item.account_name + '--' : item.account_name}${item.account_id && item.agent_name ? item.account_id + '--' : item.account_id}${item.agent_name || ''}`
        }
      }) : []

      // 巨量广告
      this.advertiserValue1 = (this.drawerItem.ocean_advertiser_ids && this.drawerItem.ocean_advertiser_ids.length) ? this.drawerItem.ocean_advertiser_ids.map(id => String(id)) : []
      this.fromAdvertiser1 = this.advertiserValue1.length ? this.drawerItem.ocean_advertiser.map((item, index) => {
        return {
          value: String(item.account_id), // 强制转换为字符串
          label: `${item.account_name && item.account_id ? item.account_name + '--' : item.account_name}${item.account_id && item.agent_name ? item.account_id + '--' : item.account_id}${item.agent_name || ''}`
        }
      }) : []
      this.advertiserObj1 = this.advertiserValue1.length ? this.drawerItem.ocean_advertiser.map((item, index) => {
        return {
          value: String(item.account_id), // 强制转换为字符串
          label: `${item.account_name && item.account_id ? item.account_name + '--' : item.account_name}${item.account_id && item.agent_name ? item.account_id + '--' : item.account_id}${item.agent_name || ''}`
        }
      }) : []

      // 平台
      this.parameter.platform_id = this.drawerItem.platform_id
    },
    handleParams1(value, index) {
      if (index === 1) {
        const str = /[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、 ]/img
        this.multipleSub1 = value.replace(str, ',')

        const str1 = /(,){1,}/img
        this.multipleSub1 = this.multipleSub1.replace(str1, ',')
      } else {
        const str = /[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、 ]/img
        this.multipleSub2 = value.replace(str, ',')

        const str1 = /(,){1,}/img
        this.multipleSub2 = this.multipleSub2.replace(str1, ',')
      }
    },
    // 选中多个副渠道号
    async multipleSubOfficialAccount() {
      if (!this.multipleSub) {
        this.$message({
          message: '必须输入 id 或 名字',
          type: 'warning'
        })
        return
      }

      // 获取渠道号
      const data = await getTheListOfOfficialAccountNovel({ name: this.multipleSub })

      // 判断是否为空
      if (!data.data.list.length) {
        this.$message({
          message: '筛选为0个，没法选中',
          type: 'warning'
        })
      }

      // 将获取到的渠道号变更下字段名
      let news = data.data.list.map((item) => {
        return {
          value: item.channel_code,
          label: item.channel_code
        }
      })

      this.fromOfficialAccount = news

      for (let i = 0; i < news.length; i++) {
        (this.officialValue.indexOf(news[i].value) < 0) && this.officialValue.push(news[i].value)
      }

      news = news.map(im => im.value)

      for (let i = 0; i < this.officialValue.length; i++) {
        news.indexOf(this.officialValue[i]) < 0 && news.push(this.officialValue[i])
      }

      this.change(news)

      data.data.list.length && this.judgeThatOneIsNotSelected(this.multipleSub, data.data.list, 'channel_code')

      this.multipleSub = null
    },

    handleParams(value) {
      const str = /[`~!@#$%^&*()_\+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\+={}|《》？：“”【】、；‘'，。、 ]/img
      this.multipleSub = value.replace(str, ',')

      const str1 = /(,){1,}/img
      this.multipleSub = this.multipleSub.replace(str1, ',')
    },

    // 选中多个广告主或者巨量广告
    async multipleSubOfficialAccount1(type) {
      if (type === 1) {
        if (!this.multipleSub1) {
          this.$message({
            message: '必须输入ADQ广告主 id 或 名字',
            type: 'warning'
          })
          return
        }
      } else {
        if (!this.multipleSub2) {
          this.$message({
            message: '必须输入巨量广告 id 或 名字',
            type: 'warning'
          })
          return
        }
      }
      this.multipleSub1 = this.multipleSub1 ? this.multipleSub1.replace(/\s/g, '') : ''
      this.multipleSub2 = this.multipleSub2 ? this.multipleSub2.replace(/\s/g, '') : ''
      const data = await getAdvertiserNovel({ name: type === 1 ? this.multipleSub1 : this.multipleSub2, type: type })
      if (!data.data.list.length) {
        this.$message({
          message: '筛选为0个，没法选中',
          type: 'warning'
        })
      }
      let news = data.data.list.map((item) => {
        return {
          value: type === 1 ? item.account_id : String(item.account_id), // 巨量广告强制转换为字符串
          label: `${item.account_name && item.account_id ? item.account_name + '--' : item.account_name}${item.account_id && item.agent_name ? item.account_id + '--' : item.account_id}${item.agent_name || ''}`
        }
      })
      if (type === 1) {
        // 广告主模块
        this.fromAdvertiser = news
        for (let i = 0; i < news.length; i++) {
          (this.advertiserValue.indexOf(news[i].value) < 0) && this.advertiserValue.push(news[i].value)
        }
        news = news.map(im => im.value)
        for (let i = 0; i < this.advertiserValue.length; i++) {
          news.indexOf(this.advertiserValue[i]) < 0 && news.push(this.advertiserValue[i])
        }
        this.change1(news)
        data.data.list.length && this.judgeThatOneIsNotSelected(this.multipleSub1, data.data.list, 'account_id')
        this.multipleSub1 = null
      } else {
        // 巨量广告模块
        this.fromAdvertiser1 = news
        for (let i = 0; i < news.length; i++) {
          (this.advertiserValue1.indexOf(news[i].value) < 0) && this.advertiserValue1.push(news[i].value)
        }
        news = news.map(im => im.value)
        for (let i = 0; i < this.advertiserValue1.length; i++) {
          news.indexOf(String(this.advertiserValue1[i])) < 0 && news.push(String(this.advertiserValue1[i]))
        }
        this.change2(news)
        data.data.list.length && this.judgeThatOneIsNotSelected(this.multipleSub2, data.data.list, 'account_id')
        this.multipleSub2 = null
      }
    },
    // 创建渲染回填时想要的结构数据
    createTheDesiredStructure(isL) {
      const obj = !isL ? {

        begin_time: this.date && this.date[0], // 开始时间
        end_time: this.date && this.date[1], // 结束时间
        recharge_begin: this.dates && this.dates[0], // 新用户充值开始时间
        recharge_end: this.dates && this.dates[1], // 新用户充值结束时间
        channel_codes: this.parameterNames.channel_codes ? [this.parameterNames.channel_codes, ...this.officialObj.map(item => item.label)] : [...this.officialObj.map(item => item.label)], // 选择的公众号的值

        master_channel_code: this.parameter.master_appid && this.parameter.master_appid.address, // 主渠道号

        // channel_codes: this.parameter.channel_codes ? [this.parameter.channel_codes, ...this.officialValue] : [...this.officialValue], // 选中的公众号的id

        // 投放组
        release_group_name: this.parameterNames.release_group_id_name,
        release_group_id: this.parameter.release_group_id && this.parameter.release_group_id.address,

        // 投手
        pitcher_id: this.parameter.pitcher_id && this.parameter.pitcher_id.address,
        pitcher_name: this.parameterNames.pitcher_id_name,

        // 书籍归属
        belong_name: this.parameterNames.book_id_name,
        book_id: this.parameter.book_id && this.parameter.book_id.address,

        // 书名
        novel_name: this.parameterNames.alias_book_id_name,
        alias_book_id: this.parameter.alias_book_id && this.parameter.alias_book_id.address,

        // 投放位置
        position_name: this.parameterNames.position_id_name,
        position_id: this.parameter.position_id && this.parameter.position_id.address,

        // 平台
        platform_id: this.parameter.platform_id,

        // 广告主
        adq_advertiser_ids: (this.advertiserValue && this.advertiserValue.length) ? this.advertiserValue : [],
        adq_advertiser: (this.advertiserObj && this.advertiserObj.length) ? this.advertiserObj.map((item) => {
          const s = item.label.split('--')
          return {
            account_id: item.value,
            account_name: s[0],
            agent_name: s[s.length - 1]
          }
        }) : [],
        // 巨量广告
        ocean_advertiser_ids: (this.advertiserValue1 && this.advertiserValue1.length) ? this.advertiserValue1 : [],
        ocean_advertiser: (this.advertiserObj1 && this.advertiserObj1.length) ? this.advertiserObj1.map((item) => {
          const s = item.label.split('--')
          return {
            account_id: item.value,
            account_name: s[0],
            agent_name: s[s.length - 1]
          }
        }) : []
      } : {}
      return obj
    },

    // 判断那个没选中
    judgeThatOneIsNotSelected(texts, arr, idName) {
      const testsr = texts.split(',')
      const unchecked = []
      testsr.forEach((text) => {
        let bool = true
        for (let i = 0; i < arr.length; i++) {
          if (String(arr[i][idName]) === String(text) || String(arr[i].account_name) === String(text)) {
            bool = false
            break
          }
        }
        bool && unchecked.push(text)
      })

      unchecked.length && this.$message({
        message: unchecked.join() + '  没被选中',
        type: 'warning'
      })
    }
  }
}
</script>

<style scoped>
.item{
   display: flex;
   align-items: center;
   margin-bottom: 20px;
}

.item .title{
    display: inline-block;
    width: 110px;
}

.checkBox{
   margin-bottom: 26px;
}

.checkBox_title{

}

.checkBox_content{

}

.content_item{

}
</style>
